import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 5: Pytanie - bezpośrednie zaangażowanie
 */
export const InstagramStoryShare5 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top accent line */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "#4E8A6E",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Emoji accent */}
        <span
          style={{
            fontSize: "110px",
            marginBottom: "48px",
          }}
        >
          🐾
        </span>

        {/* Main question */}
        <h1
          style={{
            fontSize: "72px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 40px",
            textAlign: "center",
            lineHeight: 1.25,
          }}
        >
          Znasz kogoś,
          <br />
          kto kocha zwierzaki?
        </h1>

        {/* Answer */}
        <p
          style={{
            fontSize: "48px",
            fontWeight: 700,
            color: "#3D6B52",
            margin: "0 0 48px",
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          Pokaż mu tę stronę!
        </p>

        {/* Divider */}
        <div
          style={{
            width: "100px",
            height: "6px",
            background: "#4E8A6E",
            borderRadius: "3px",
            marginBottom: "48px",
          }}
        />

        {/* Help message */}
        <p
          style={{
            fontSize: "42px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 72px",
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          Może chce pomóc,
          <br />
          tylko nie wie jak
        </p>

        {/* CTA pill */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.12)",
            borderRadius: "50px",
            padding: "28px 56px",
          }}
        >
          <p
            style={{
              fontSize: "40px",
              fontWeight: 700,
              color: "#3D6B52",
              margin: 0,
              textAlign: "center",
            }}
          >
            Udostępnianie też pomaga 💚
          </p>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "12px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "52px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
